import {NavLink} from "react-router-dom";
import React, { Fragment } from "react";

const TitleNav = () => (
  <Fragment>
  <div className="navbar-nav mr-auto">
    <NavLink
      to="/"
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      Home
    </NavLink>
    <NavLink
      to="/about-us"
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      About Us
    </NavLink>
    <NavLink
      to={"/originator"}
      state = {{ from: 'some_value'}}
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      Portal
    </NavLink>
    <NavLink
      to="/support"
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      Contact Us
    </NavLink>
  </div>
  </Fragment>
);

export default TitleNav;
